import { render } from "./DigitalTransform.vue?vue&type=template&id=242954d4&scoped=true&lang=pug"
import script from "./DigitalTransform.vue?vue&type=script&lang=ts"
export * from "./DigitalTransform.vue?vue&type=script&lang=ts"

import "./DigitalTransform.vue?vue&type=style&index=0&id=242954d4&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-242954d4"

export default script